<template>
  <Unauthenticated>
    <div class="top-margin">

      <form v-on:submit.prevent="login">
        <img src="/logo.png" />

        <div class="error" v-if="errors && errors.all">{{ errors.all }}</div>

        <div :key="site" v-for="site in sites">
          <button @click="choose(site)" type="submit" value="Log In" class="w-100">{{ site  }}</button>
        </div>

        <a class="other" href="/password">Sign out</a>

      </form>
    </div>
  </Unauthenticated>
</template>

<script>
import Unauthenticated from '@/components/_layouts/Unauthenticated'
// import {api} from "@/api";

export default {
  name: "ChooseStore",
  components: { Unauthenticated },
  data() {
    return {
      errors: {},
      sites: []
    }
  },
  async created() {
    const siteJson = await window.localStorage.getItem("sites");

    this.sites = JSON.parse(siteJson);
    if (this.sites.length == 1) {
      this.choose(this.sites[0]);
    }
    
  },
  methods: {
    choose(site) {
      window.localStorage.setItem("site", site);
      this.$router.push('/station')
    }
  }
}
</script>

<style scoped lang="scss">

form {
    border-radius: 0.5rem;
    background-color: var(--secondary-colour);
  max-width: 400px;
  padding: 2rem;
  margin: 0px auto;
  margin-top: 1rem;
  position: relative;

  font-size: 1em;
  font-family: 'Architects Daughter';
  img { width: 100%; }

  button {
    margin-bottom: 1rem;
    padding: 1rem;
    width: 100%;
    background-color: var(--action-colour);
    font-weight: bold;
    text-transform: capitalize;
    margin-left: 0px !important;
  }

  button { font-size: 1rem; font-family: 'Architects Daughter'; }

}



.other {
  display: block;
  text-align: right;
  font-size: 1em;
  margin-top: 10px;
}

@media screen and (max-width: 840px) {
  form {
    border: none;
    padding: 0em;
    max-width: none !important;

  }
}

</style>
